import { detectCloseElement } from "./helper";
/*==================== Header ====================*/
/**
 * @param header
 */
export const header = {
	scrollActive: function () {
		let height = $("header").height();
		if ($(window).scrollTop() > height) {
			$("header").addClass("active");
		} else {
			$("header").removeClass("active");
		}
	},
	headerSearch: function () {
	},
	mobile: function () {
		// Search
		$(".tool-mobile .header-search").on("click", function (e) {
			e.preventDefault();
			$('body').toggleClass("openSearch");
			$('input[type="search"]').focus();
		});
		// hamburger
		$(".header-search button").on("click", function (e) {
			$('body').removeClass("openSearch")
		});
		$(".hamburger").on("click", function (e) {
			e.preventDefault();
			$(this).toggleClass("active")
			$('.header-menu-mobile').toggleClass("active")
		});
		if (window.matchMedia("(max-width: 1023.98px)").matches) {
			$(".header-menu").appendTo(".header-menu-mobile .wrap-menu");
		}
		$('.header-menu-mobile li[class*="menu-item-has-children"] > a').on('click', function (e) {
			e.preventDefault();
			$(this).toggleClass('dropdown-active').next().slideToggle().parent().siblings().find('a').removeClass('dropdown-active').next().slideUp();
			// $('.header-menu-mobile .close').addClass('back');
		});
		$('.header-menu-mobile .close').on('click', function (e) {
			// const isChild = $('.header-menu-mobile .list-dropdown-menu.active').length > 0;
			// if (isChild) {
			// 	$('.header-menu-mobile .list-dropdown-menu.active').removeClass('active');
			// 	$('.header-menu-mobile .close').removeClass('back');
			// } else {
			// }
			$('.header-menu-mobile').removeClass('active');
		});
	},
	init: function () {
		header.headerSearch();
		header.scrollActive();
		header.mobile();
	},
};
document.addEventListener(
	"scroll",
	function (e) {
		header.scrollActive();
	},
	true
);
